<template>
    <div>
        <HorizontalTopbarInside/>
        <b-container class="container">
            <AppBreadcrumb/>
            <validation-observer class="w-100" ref="observer">
                <b-card>
                    <header
                            class="header"
                            style="">
                        <h2
                                class="text-white"
                                style="text-align: center"
                        >{{$t('Application form') }}
                        </h2>
                    </header>
                    <h4 style="">{{$t('message.Personal_info')}}</h4>
                    <b-row>
                        <b-col md="6" class="mt-4">
                            <!--          <validation-provider rules="required" v-slot="{errors}" name="PNFL">-->
                            <!--            <input :placeholder="$t('message.PINFL')" class="form-control" v-model="form.pinfl" @input="getPinflInput" type="text" />-->

                            <!--            <span class="text-danger">{{errors[0]}}</span>-->
                            <!--          </validation-provider>-->
                            <br>
                            <validation-provider rules="required" v-slot="{errors}" name="Ism">
                                <b-form-input :placeholder="$t('message.First_name')"
                                              v-model="form.first_name"></b-form-input>
                                <span class="text-danger">{{errors[0]}}</span>
                            </validation-provider>
                            <br>
                            <validation-provider rules="required" v-slot="{errors}" name="Familya">
                                <b-form-input :placeholder="$t('message.Last_name')"
                                              v-model="form.last_name"></b-form-input>
                                <span class="text-danger">{{errors[0]}}</span>
                            </validation-provider>
                            <br>
                            <validation-provider rules="required" v-slot="{errors}" name="Sharifi">
                                <b-form-input :placeholder="$t('message.Middle_name')"
                                              v-model="form.middle_name"></b-form-input>
                                <span class="text-danger">{{errors[0]}}</span>
                            </validation-provider>
                            <br>
                            <validation-provider rules="required" v-slot="{errors}" name="Telefon raqami">
                                <b-form-input :placeholder="$t('message.Tel_number')"
                                              v-model="form.mobile"
                                              @input="checkIfMobileExists"></b-form-input>
                                <span class="text-danger">{{errors[0]}}</span>
                            </validation-provider>
                        </b-col>
                        <b-col md="6" class="mt-4">
                            <validation-provider rules="required" v-slot="{errors}" :name="$t('Highest level')">
                                <h6>{{$t('Highest level')}}</h6>
                                <b-form-select
                                        v-model="form.education_id"
                                        :options="education"
                                        text-field="name"
                                        value-field="id"
                                        class="form-select d-flex"
                                        aria-label="Default select example"></b-form-select>
                                <span class="text-danger">{{errors[0]}}</span>
                            </validation-provider>
                            <br>
                            <!--          <b-form-input placeholder="Yashash joyi"></b-form-input>-->
                            <div>

                                <validation-provider rules="required" v-slot="{errors}" :name="$t('Address line')">
                                    <h6>{{$t('Address line')}}</h6>
                                    <b-form-input
                                            v-model="form.address"></b-form-input>
                                    <span class="text-danger">{{errors[0]}}</span>
                                </validation-provider>

                                <validation-provider rules="required" v-slot="{errors}" :name="$t('Country')">
                                    <br>
                                    <h6>{{$t('Country')}}</h6>
                                    <b-form-select
                                            v-model="form.region_id"
                                            :options="regions"
                                            text-field="name"
                                            value-field="id"
                                            @input="fetchRayons"
                                            class="form-select d-flex"
                                            aria-label="Default select example"></b-form-select>
                                    <span class="text-danger">{{errors[0]}}</span>
                                </validation-provider>
                            </div>
                            <br>

                        </b-col>
                    </b-row>
                    <h4 style="color:#185d89">{{$t('Work experience')}}</h4>
                    <b-row>
                        <b-col md="6" class="mt-4" offset="3">
                            <div class="mb-3">

                                <label>{{$t('Cover letter')}}</label>
                                <validation-provider rules="required" v-slot="{errors, validate}"
                                                     :name="$t('Cover letter')">
                                    <input
                                            class="form-control"
                                            type="file"
                                            @change="uploadFiles($event,'cover_letter');validate($event)"
                                            ref="file"
                                            accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                                    <span class="text-danger">{{errors[0]}}</span>
                                </validation-provider>
                                <br>

                                <label>{{$t('CV')}}</label>
                                <validation-provider rules="required" v-slot="{errors, validate}" :name="$t('CV')">
                                    <input
                                            class="form-control"
                                            type="file"
                                            @change="uploadFiles($event,'cv');validate($event)"
                                            ref="file"
                                            accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                                    <span class="text-danger">{{errors[0]}}</span>
                                </validation-provider>
                                <br>

                                <!--              <label>{{$t('Statement of your vision of the post')}}</label>-->
                                <!--              <validation-provider rules="required" v-slot="{errors, validate}" :name="$t('Statement of your vision of the post')">-->
                                <!--                  <input-->
                                <!--                          class="form-control"-->
                                <!--                          type="file"-->
                                <!--                          @change="uploadFiles($event,'statement');validate($event)"-->
                                <!--                          ref="file"-->
                                <!--                          accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">-->
                                <!--                  <span class="text-danger">{{errors[0]}}</span>-->
                                <!--              </validation-provider>-->
                                <!--              <br>-->

                                <label>{{$t('Portfolio')}}</label>
                                <validation-provider rules="required" v-slot="{errors, validate}"
                                                     :name="$t('Portfolio')">
                                    <input
                                            class="form-control"
                                            type="file"
                                            @change="uploadFiles($event,'t_portfolio');validate($event)"
                                            ref="file"
                                            accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                                    <span class="text-danger">{{errors[0]}}</span>
                                </validation-provider>
                                <br>

                                <label>{{$t('Higher education certificate')}}</label>
                                <validation-provider rules="required" v-slot="{errors, validate}"
                                                     :name="$t('Higher education certificate')">
                                    <input
                                            class="form-control"
                                            type="file"
                                            @change="uploadFiles($event,'diplomas');validate($event)"
                                            ref="file"
                                            accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                                    <span class="text-danger">{{errors[0]}}</span>
                                </validation-provider>
                                <br>

                                <!--            <label>{{$t('message.Objective')}}</label>-->
                                <!--            <validation-provider rules="required" v-slot="{errors, validate}" :name="$t('message.Objective')">-->
                                <!--            <input-->
                                <!--                class="form-control"-->
                                <!--                type="file"-->
                                <!--                @change="uploadFiles($event,'objective');validate($event)"-->
                                <!--                ref="file"-->
                                <!--                accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">-->
                                <!--              <span class="text-danger">{{errors[0]}}</span>-->
                                <!--            </validation-provider>-->
                                <!--            <br>-->
                                <label>{{$t('Upload detailed statement (max 700 words)')}}</label>
                                <validation-provider rules="required" v-slot="{errors, validate}"
                                                     :name="$t('Upload detailed (max. 700 words) acceptable .doc, .pdf, .jpg')">

                                    <input
                                            class="form-control"
                                            type="file"
                                            @change="uploadFiles($event,'objective');validate($event)"
                                            ref="file"
                                            accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">

                                    <span class="text-danger">{{errors[0]}}</span>
                                </validation-provider>
                                <br>
                                <!--<br>
                                <div v-for="(exp, expIndex) in form.lidership_experiences" :key="expIndex" class="w-100 mb-3">
                                  <b-row>
                                    <b-col md="8">
                                      <validation-provider rules="required" v-slot="{errors}" :name="$t('message.Edu_staj')">
                                        <label>{{$t('message.Edu_staj')}}</label>
                                        <b-form-select
                                            v-model="exp.lidership_experience_id"
                                            :options="getExperienceOptions"
                                            text-field="name"
                                            value-field="id"
                                            class="form-select d-flex mb-3"
                                            aria-label="Default select example"></b-form-select>
                                        <span class="text-danger">{{errors[0]}}</span>
                                      </validation-provider>
                                    </b-col>
                                    <b-col md="3">
                                      <validation-provider rules="required" v-slot="{errors}" :name="$t('message.Staj')">
                                        <b-form-input v-model="exp.year" class="w-100 mt-4" type="number" :min="1" :placeholder="$t('message.Staj')"></b-form-input>
                                        <span class="text-danger">{{errors[0]}}</span>
                                      </validation-provider>
                                    </b-col>
                    &lt;!&ndash;                <b-col md="1">&ndash;&gt;
                    &lt;!&ndash;                  <i class="bx bx-x font-size-20 mt-2" @click="removeLidership(langIndex)"></i>&ndash;&gt;
                    &lt;!&ndash;                </b-col>&ndash;&gt;
                                  </b-row>
                                </div>-->
                                <!--            <div class="w-100 mt-2 d-flex justify-content-end">-->
                                <!--              <b-button variant="success" size="sm" @click="increaseLidershipExp">-->
                                <!--                <i class="bx bx-plus"></i>-->
                                <!--              </b-button>-->
                                <!--            </div>-->
                            </div>
                            <!--          <div class="w-100">-->
                            <!--            <validation-provider rules="required" v-slot="{errors, validate}" :name="$t('message.Year')">-->
                            <!--&lt;!&ndash;              <b-form-file v-model="form.workable_document"></b-form-file>&ndash;&gt;-->
                            <!--              <label>{{$t('message.Entitling')}}</label>-->
                            <!--              <input class="form-control" ref="file" type="file" @change="uploadFiles($event,'workable_document');validate($event)">-->
                            <!--              <span class="text-danger">{{errors[0]}}</span>-->
                            <!--            </validation-provider>-->
                            <!--          </div>-->
                        </b-col>
                        <!--        <b-col md="6" class="mt-5">-->
                        <!--          <div class="w-100">-->
                        <!--            <b-form-radio-group-->
                        <!--                v-model="form.has_memorative_badge"-->
                        <!--                :aria-describedby="ariaDescribedby"-->
                        <!--                name="radio-sub-component"-->
                        <!--            >-->
                        <!--            <div class="d-flex justify-content-between mb-2">-->
                        <!--              <label>{{$t('message.Memorative_badge')}}</label>-->
                        <!--              <b-form-radio :value="true" size="lg"><span class="ms-2">{{$t('message.Available')}}</span></b-form-radio>-->
                        <!--              <b-form-radio :value="false" size="lg"><span class="ms-2">{{$t('message.NotAvailable')}}</span></b-form-radio>-->
                        <!--            </div>-->
                        <!--            </b-form-radio-group>-->
                        <!--          </div>-->
                        <!--&lt;!&ndash;          <label for="certificate">{{$t('message.Certificate')}}</label>&ndash;&gt;-->
                        <!--          <validation-provider rules="required" v-slot="{errors}" :name="$t('message.Memorative_badge')"-->
                        <!--                               v-if="form.has_memorative_badge">-->
                        <!--            <b-form-input :placeholder="$t('message.Memorative_badge')" v-model="form.memorative_badge" class="mt-4" ></b-form-input>-->
                        <!--            <span class="text-danger">{{errors[0]}}</span>-->
                        <!--          </validation-provider>-->
                        <!--          <br>-->
                        <!--          <validation-provider rules="required" v-slot="{errors}" :name="$t('message.Category')">-->
                        <!--            <label class="mt-1">{{$t('message.Category')}}</label>-->
                        <!--            <b-form-select-->
                        <!--                v-model="form.category_id"-->
                        <!--                :options="category"-->
                        <!--                text-field="name"-->
                        <!--                value-field="id"-->
                        <!--                class="form-select d-flex"-->
                        <!--                aria-label="Default select example"></b-form-select>-->
                        <!--            <span class="text-danger">{{errors[0]}}</span>-->
                        <!--          </validation-provider>-->
                        <!--          <br>-->
                        <!--          <div v-for="(lang,langIndex) in form.applicationLangLevels" :key="langIndex" class="mb-3">-->
                        <!--            <b-row>-->
                        <!--              <b-col md="3" class="mt-2">-->
                        <!--                <validation-provider rules="required" v-slot="{errors}" :name="$t('message.Foreign_lang')">-->
                        <!--                  <label>{{$t('Language skills')}}</label>-->
                        <!--                  <b-form-select-->
                        <!--                      v-model="lang.lang_id"-->
                        <!--                      :options="language_level"-->
                        <!--                      text-field="name"-->
                        <!--                      value-field="id"-->
                        <!--                      class="form-select d-flex mb-3"-->
                        <!--                      aria-label="Default select example"></b-form-select>-->
                        <!--                  <span class="text-danger">{{errors[0]}}</span>-->
                        <!--                </validation-provider>-->
                        <!--              </b-col>-->
                        <!--              <b-col md="4" class="mt-2">-->
                        <!--                <validation-provider rules="required" v-slot="{errors}" :name="$t('message.Level')">-->
                        <!--                  <label>{{$t('message.Level')}}</label>-->
                        <!--                  <b-form-select-->
                        <!--                      v-model="lang.level_id"-->
                        <!--                      :options="langLevels"-->
                        <!--                      text-field="name"-->
                        <!--                      value-field="id"-->
                        <!--                      class="form-select d-flex mb-3"-->
                        <!--                      aria-label="Default select example"></b-form-select>-->
                        <!--                  <span class="text-danger">{{errors[0]}}</span>-->
                        <!--                </validation-provider>-->
                        <!--              </b-col>-->
                        <!--              <b-col md="4">-->
                        <!--&lt;!&ndash;                <b-form-file v-model="lang.certificate"></b-form-file>&ndash;&gt;-->
                        <!--                <h6 class="">{{$t('message.UploadCertificate')}}</h6>-->
                        <!--                <input class="form-control" ref="file" type="file" @change="uploadLangFiles($event,langIndex);validate($event)">-->
                        <!--              </b-col>-->
                        <!--              <b-col md="1" class="mt-2">-->
                        <!--                <i class="bx bx-x font-size-20 mt-2" @click="removeLangLevel(langIndex)"></i>-->
                        <!--              </b-col>-->
                        <!--            </b-row>-->
                        <!--          </div>-->
                        <!--          <div class="w-100 d-flex justify-content-end mt-1">-->
                        <!--            <b-button variant="success" size="sm" @click="increaseLevel">-->
                        <!--              <i class="bx bx-plus"></i>-->
                        <!--            </b-button>-->
                        <!--          </div>-->
                        <!--          <div class="w-100 mt-4">-->
                        <!--            <b-row>-->
                        <!--              <b-col md="6">-->
                        <!--                <validation-provider rules="required" v-slot="{errors}" :name="$t('message.LastWorkPlace')">-->
                        <!--                <label for="last_work_place">{{$t('message.LastWorkPlace')}}</label>-->
                        <!--                <b-form-input v-model="form.last_work_place" class="w-100"></b-form-input>-->
                        <!--                <span class="text-danger">{{errors[0]}}</span>-->
                        <!--                </validation-provider>-->
                        <!--              </b-col>-->
                        <!--              <b-col md="6">-->
                        <!--                <validation-provider rules="required" v-slot="{errors}" :name="$t('message.ReasonDischarging')">-->
                        <!--                <label for="reason_discharging">{{$t('message.ReasonDischarging')}}</label>-->
                        <!--                <b-form-input v-model="form.reason_discharging" class="w-100"></b-form-input>-->
                        <!--                <span class="text-danger">{{errors[0]}}</span>-->
                        <!--                </validation-provider>-->
                        <!--              </b-col>-->
                        <!--            </b-row>-->
                        <!--          </div>-->

                        <!--        </b-col>-->
                    </b-row>
                    <!--      <h4 style="color:#185d89">{{$t('message.Achievements')}}</h4>-->
                    <!--      <b-row>-->
                    <!--      <b-col md="6" class="mt-5">-->
                    <!--        <label>{{$t('message.Government_reward')}}</label>-->
                    <!--        <input class="form-control" type="file" @change="uploadFiles($event,'government_reward');validate($event)" ref="file">-->
                    <!--&lt;!&ndash;        <br>&ndash;&gt;-->
                    <!--&lt;!&ndash;        <label>{{$t('message.Teacher_competition')}}</label>&ndash;&gt;-->
                    <!--&lt;!&ndash;        <input class="form-control" ref="file" type="file" @change="uploadFiles($event,'teacher_competition');validate($event)">&ndash;&gt;-->
                    <!--      </b-col>-->
                    <!--      <b-col md="6" class="mt-5">-->
                    <!--&lt;!&ndash;        <label>{{$t('message.Network_reward')}}</label>&ndash;&gt;-->
                    <!--&lt;!&ndash;        <input class="form-control" ref="file" type="file" @change="uploadFiles($event,'network_reward');validate($event)">&ndash;&gt;-->
                    <!--&lt;!&ndash;        <br>&ndash;&gt;-->
                    <!--        <label>{{$t('message.Other_reward')}}</label>-->
                    <!--        <input class="form-control" ref="file" type="file" @change="uploadFiles($event,'other_reward');validate($event)">-->
                    <!--      </b-col>-->
                    <!--      </b-row>-->
                    <!--      <div class="check">-->
                    <!--        <input type="checkbox" v-model="receive_sms_offer">-->
                    <!--        <p>Получить приглашение <br>-->
                    <!--          по телефон номеру</p>-->
                    <!--      </div>-->
                    <!--      <div>-->
                    <!--        <div class="form-check form-switch form-switch-lg mb-3">-->
                    <!--          <input-->
                    <!--              class="form-check-input"-->
                    <!--              type="checkbox"-->
                    <!--              checked-->
                    <!--              v-model="form.receive_sms_offer"-->
                    <!--              style="border:none"-->
                    <!--          />-->
                    <!--          <label class="form-check-label mt-3" for="SwitchCheckSizelg"-->
                    <!--          >Получить приглашение по телефон номеру</label>-->
                    <!--                    </div>-->
                    <!--                  </div>-->
                    <div class="mt-4">
                        <div class="justify-content-center d-flex m-4" v-if="smsCodeSended">
                            <b-form-input v-model="form.smsCode" :placeholder="$t('message.SmsCode')"
                                          class="w-50"></b-form-input>
                        </div>
                        <div class="mt-1 text-center">
                            <b-button
                                    style="background-color: #185d89"
                                    class="btn mt-4"
                                    size="lg"
                                    @click="handleSubmit"
                            >
                                {{$t('message.Send')}}
                            </b-button>
                        </div>
                    </div>
                </b-card>
            </validation-observer>
        </b-container>
    </div>
</template>

<script>
    import {
        getSchoolFJobVacancyCreds, checkApplicationMobile
        // , sendVacancySmsCode
    } from "../../../../api/school_job_vacancy_creds";
    import {getRayons} from "../../../../api/regions";
    import {getSchools, getUserByPinfl} from "../../../../api/schools";
    import {getLanguageLevels} from "../../../../api/language-level";
    // import vSelect from "vue-select";
    import 'vue-select/dist/vue-select.css';
    import {
        addSchoolFVacancyApplications,
        // addSchoolVacancyApplications
    } from "../../../../api/school-vacany-applications";
    import {getLidershipExperience} from "../../../../api/lidership_experience";
    import {getExperience} from "../../../../api/work_experience";
    import {getCategory} from "../../../../api/categories";
    import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
    import * as rules from 'vee-validate/dist/rules';
    import {messages} from 'vee-validate/dist/locale/ru.json';


    Object.keys(rules).forEach(rule => {
        extend(rule, {
            ...rules[rule],
            message: messages[rule]
        });
    });
    import {mask} from 'vue-the-mask';
    import HorizontalTopbarInside from "../../../../components/horizontal-topbar-inside";
    import {getLanguageLevelCategories} from "../../../../api/language-level-categories";
    import AppBreadcrumb from "../../../layouts/AppBreadcrumb";

    export default {
        name: "Register",
        directives: {mask},
        components: {
            AppBreadcrumb,
            HorizontalTopbarInside,
            ValidationObserver,
            ValidationProvider,
        },
        data() {
            return {
                form: {
                    first_name: '',
                    last_name: '',
                    middle_name: '',
                    mobile: '',
                    education_id: null,
                    pinfl: '',
                    has_memorative_badge: false,
                    region_id: null,
                    rayon_id: null,
                    address: '',
                    language_level: null,
                    objective: null,
                    experience_id: null,
                    lidership_experiences: [{lidership_experience_id: null, year: null}],
                    memorative_badge: null,
                    category_id: null,
                    government_reward: null,
                    network_reward: null,
                    teacher_competition: null,
                    workable_document: null,
                    other_reward: null,
                    receive_sms_offer: true,
                    vacancy_id: this.$route.params.vacancyId,
                    applicationLangLevels: [{lang_id: null, level_id: null, certificate: null,}],
                    smsCode: '',
                    last_work_place: '',
                    reason_discharging: '',
                },
                langLevels: [{id: null, name: this.$t('message.Level')}],
                regions: [],
                rayons: [{id: null, nameuz: this.$t('message.LivingRayon')}],
                schools: [],
                position_level: [],
                positions: [],
                lesson_language: [],
                second_lang: [],
                language_level: [{id: null, name: this.$t('Foreign_lang')}],
                work_experience: [{id: null, name: this.$t('message.Work_experience')}],
                education: [],
                job_type: [],
                payment_type: [],
                work_place: [],
                lidership_experience: [{id: null, name: this.$t('message.Edu_staj')}],
                category: [{id: null, name: this.$t('message.Category')}],
                checkMobileExistsTimeout: null,
                canRegister: true,
                smsCodeSended: false,
            }
        },
        created() {
            this.fetchCreds()
            this.fetchKnowledgeLevel()
            this.fetchLidershipExperience()
            this.fetchCategory()
            this.fetchExperience()
            this.fetchLevelCategories()
            this.fetchRayons()
            this.fetchSchools()
        },
        computed: {
            getExperienceOptions() {
                return this.lidership_experience;
            },
        },
        methods: {
            fetchCreds() {
                getSchoolFJobVacancyCreds().then(response => {

                    this.regions = response.data.regions.original.data.map(item => {
                        var locName = item.nameru;
                        if (this.$i18n.locale === 'uz') {
                            locName = item.nameuzlatn;
                        } else if (this.$i18n.locale === 'en') {
                            locName = item.nameuzlatn;
                        }
                        return Object.assign(item, {
                            name: locName
                        })
                    });
                    this.position_level = response.data.position_levels.original.data;
                    this.lesson_language = response.data.lesson_languages.original.data;
                    this.second_lang = response.data.lesson_languages.original.data;
                    this.work_experience = response.data.work_experiences.original.data;
                    this.work_experience.unshift({id: null, name: this.$t('message.Work_experience')})
                    this.education = response.data.educations.original.data;
                    this.job_type = response.data.job_types.original.data;
                    this.payment_type = response.data.payments.original.data;
                    this.work_place = response.data.work_places.original.data;
                    this.lidership_experience = response.data.lidership_experience.original.data;
                    this.lidership_experience.unshift({id: null, name: this.$t('message.Edu_staj')})
                    this.category = response.data.category.original.data;
                })
            },
            fetchLevelCategories() {
                getLanguageLevelCategories().then(res => {
                    this.langLevels = res.data.data;
                })
            },
            fetchRayons() {
                getRayons(this.form.region_id).then(response => {
                    this.rayons = response.data.data.map(item => {
                        var locName = item.nameru;
                        if (this.$i18n.locale === 'uz') {
                            locName = item.nameuzlatn;
                        } else if (this.$i18n.locale === 'en') {
                            locName = item.nameuzlatn;
                        }
                        return Object.assign(item, {
                            name: locName
                        })
                    });
                    // eslint-disable-next-line no-console
                    console.log('Rayons', this.rayons);
                })
            },
            fetchSchools() {
                getSchools({oblastid: this.form.region_id, regionid: this.form.rayon_id}).then(response => {
                    this.schools = response.data.data
                })
            },
            fetchKnowledgeLevel() {
                getLanguageLevels().then(response => {
                    this.language_level = response.data.data
                })
            },
            fetchExperience() {
                getExperience().then(response => {
                    this.work_experience = response.data.data
                })
            },
            fetchLidershipExperience() {
                getLidershipExperience().then(response => {
                    this.lidership_experience = response.data.data
                })
            },
            uploadFiles(e, r) {
                this.form[r] = e.target.files[0];
            },
            uploadLangFiles(e, index) {
                this.form.applicationLangLevels[index].certificate = e.target.files[0]
            },
            increaseLevel() {
                this.form.applicationLangLevels.push({lang_id: null, level_id: null, certificate: null})
            },
            increaseLidershipExp() {
                this.form.lidership_experiences.push({lidership_experience_id: null, year: null})
            },
            removeLidership(index) {
                this.form.lidership_experiences.splice(index, 1);
            },
            removeLangLevel(index) {
                this.form.applicationLangLevels.splice(index, 1)
            },
            fetchCategory() {
                getCategory().then(response => {
                    this.category = response.data.data
                })
            },
            checkIfMobileExists() {
                // eslint-disable-next-line no-console
                console.log(this.form.mobile.length)
                if (this.form.mobile.length === 17) {
                    clearTimeout(this.checkMobileExistsTimeout)
                    this.checkMobileExistsTimeout = setTimeout(() => {
                        checkApplicationMobile({
                            vacancy_id: this.$route.params.vacancyId,
                            mobile: this.form.mobile.replace(/\)|\(|-|\+/gi, '')
                        }).then(res => {
                            if (res.data.data) {
                                this.canRegister = false;
                                this.$vs.notification({
                                    flat: true,
                                    color: 'danger',
                                    position: "top-right",
                                    title: this.$t('message.MobileAlreadyExists'),
                                })
                            } else {
                                this.canRegister = true
                                this.$vs.notification({
                                    flat: true,
                                    color: 'success',
                                    position: "top-right",
                                    title: this.$t('message.MobileNotExists'),
                                })
                            }
                        })
                    }, 600);
                }
            },
            getPinflInput() {
                const regExp = new RegExp('^[0-9]+$');
                if (regExp.test(this.form.pinfl)) {
                    if (this.form.pinfl.length > 14) {
                        this.form.pinfl = this.form.pinfl.slice(0, 14);
                    }
                    if (this.form.pinfl.length === 14) {
                        getUserByPinfl({pinfl: this.form.pinfl}).then(res => {
                            let resData = res.data.data.result;
                            if (resData) {
                                this.form.first_name = resData.FirstName;
                                this.form.last_name = resData.LastName;
                                this.form.middle_name = resData.FamilyName;
                                this.form.region_id = resData.OblastId;
                                this.form.rayon_id = resData.RegionId;
                                this.$vs.notification({
                                    flat: true,
                                    color: 'success',
                                    position: "top-right",
                                    title: this.$t('message.Success'),
                                    text: this.$t('message.PinflFound')
                                })
                            } else {
                                this.$vs.notification({
                                    flat: true,
                                    color: 'danger',
                                    position: "top-right",
                                    title: this.$t('message.NotFound'),
                                    text: this.$t('message.PinflNotFound')
                                })
                            }
                        })
                    }
                } else {
                    this.form.pinfl = this.form.pinfl.slice(0, -1);
                }
            },
            async handleSubmit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid && this.canRegister) {
                    this.form.mobile = this.form.mobile.replace(/\)|\(|-|\+/gi, '')
                    const form = new FormData()
                    for (let a in this.form) {
                        if (a === 'applicationLangLevels') {
                            for (let i of this.form[a]) {
                                form.append('langImage' + i.lang_id, i.certificate)
                                // form.append('applicationLangLevels[]',i)
                            }
                            form.append(a, JSON.stringify(this.form[a]))
                        } else if (a === "language_level") {
                            form.append(a, JSON.stringify(this.form[a]))
                        } else if (a === "lidership_experiences") {
                            form.append(a, JSON.stringify(this.form[a]))
                        } else {
                            // if(labels.includes(a)){
                            //   if(this.form[a]) {
                            //     form.append(a, this.form[a].id)
                            //   }
                            // } else{
                            //   form.append(a, this.form[a])
                            // }
                            form.append(a, this.form[a])
                        }
                    }
                    // eslint-disable-next-line no-unused-vars
                    addSchoolFVacancyApplications(form).then(res => {
                        if (res.data.data === 'wrongCode') {
                            this.$vs.notification({
                                flat: true,
                                color: 'danger',
                                position: "top-right",
                                title: this.$t('message.WrongSmsCode'),
                            })
                        } else {
                            // this.$router.push({name:'frankinformation',params: {id: this.$router.params.id}})
                            this.$vs.notification({
                                flat: true,
                                color: 'success',
                                position: "top-right",
                                title: this.$t('Your application has been accepted. Specialists will contact you'),
                            })

                            this.$router.push({name: 'fvacancyindex'})
                            // this.$router.push({name:'frankinformation',params:{id:res.data.vacancy_id}})
                            // @click="$router.push({name: 'fregister', params: {vacancyId: $route.params.id}})"
                        }
                    })

                    /*                      if(!this.smsCodeSended) {
                                            sendVacancySmsCode({vacancy_id: this.$route.params.vacancyId,
                                              mobile: this.form.mobile.replace(/\)|\(|-|\+/gi, '')}).then(() => {
                                                this.smsCodeSended = true;
                                            })
                                          }
                                          else {
                                            this.form.mobile = this.form.mobile.replace(/\)|\(|-|\+/gi, '')
                                            const form = new FormData()
                                            for(let a in this.form){
                                              if(a === 'applicationLangLevels') {
                                                for(let i of this.form[a]) {
                                                  form.append('langImage'+i.lang_id,i.certificate)
                                                  // form.append('applicationLangLevels[]',i)
                                                }
                                                form.append(a, JSON.stringify(this.form[a]))
                                              }
                                              else if(a === "language_level"){
                                                form.append(a, JSON.stringify(this.form[a]))
                                              }
                                              else if(a === "lidership_experiences") {
                                                form.append(a,JSON.stringify(this.form[a]))
                                              }
                                              else{
                                                // if(labels.includes(a)){
                                                //   if(this.form[a]) {
                                                //     form.append(a, this.form[a].id)
                                                //   }
                                                // } else{
                                                //   form.append(a, this.form[a])
                                                // }
                                                form.append(a, this.form[a])
                                              }
                                            }
                                            // eslint-disable-next-line no-unused-vars
                                          }*/
                }
            },
        }
    }
</script>

<style scoped>
    h4 {
        text-align: center;
        color: #185d89;
        padding-top: 50px;
    }

    .btn {
        /*margin-left: 150px;*/
        border-radius: 15px;
    }

    input[type="checkbox"] {
        cursor: pointer;
        margin-top: 20px;
        position: relative;
        width: 50px;
        height: 25px;
        -webkit-appearance: none;
        background: #c6c6c6;
        outline: none;
        border-radius: 20px;
        transition: .5s;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
    }

    input:checked[type="checkbox"] {
        background: #f0ac39;

    }

    input[type="checkbox"]:before {
        content: '';
        position: absolute;
        width: 25px;
        height: 25px;
        border-radius: 30px;
        top: 0;
        left: 0;
        background: #fff;
        transform: scale(1.1);
        transition: .5s;
        box-shadow: 0 2px 5px rgba(0, 0, 0, .2);
    }

    input:checked[type="checkbox"]:before {
        left: 30px;
    }

    .check {
        margin-left: 40px;
        display: flex;
    }

    p {
        margin-top: 15px;
        margin-left: 20px;
        font-weight: bold;
    }

    .container {
        border-radius: 15px;
        margin-top: 170px
    }

    .header {
        background-color: #185d89;
        padding-top: 30px;
        padding-bottom: 30px;
        border-radius: 15px
    }
</style>
